__turbopack_context__.v({
  "closeBtn": "OtpModal-module-scss-module__VpmlfG__closeBtn",
  "digit": "OtpModal-module-scss-module__VpmlfG__digit",
  "digitError": "OtpModal-module-scss-module__VpmlfG__digitError",
  "digits": "OtpModal-module-scss-module__VpmlfG__digits",
  "error": "OtpModal-module-scss-module__VpmlfG__error",
  "fadeIn": "OtpModal-module-scss-module__VpmlfG__fadeIn",
  "icon": "OtpModal-module-scss-module__VpmlfG__icon",
  "modal": "OtpModal-module-scss-module__VpmlfG__modal",
  "overlay": "OtpModal-module-scss-module__VpmlfG__overlay",
  "resendLink": "OtpModal-module-scss-module__VpmlfG__resendLink",
  "resendPrompt": "OtpModal-module-scss-module__VpmlfG__resendPrompt",
  "shimmer": "OtpModal-module-scss-module__VpmlfG__shimmer",
  "slideUp": "OtpModal-module-scss-module__VpmlfG__slideUp",
  "spin": "OtpModal-module-scss-module__VpmlfG__spin",
  "spinner": "OtpModal-module-scss-module__VpmlfG__spinner",
  "subtitle": "OtpModal-module-scss-module__VpmlfG__subtitle",
  "success": "OtpModal-module-scss-module__VpmlfG__success",
  "title": "OtpModal-module-scss-module__VpmlfG__title",
  "verifyBtn": "OtpModal-module-scss-module__VpmlfG__verifyBtn",
});
